<div class="logo">
  <ng-container *ngIf="vendorConfig?.vendorSource !== VendorSource.TGA">
    <img id="logo-image" [src]="customLogo ?? imgSrc" [ngStyle]="{width: width, height: '35px' }" alt="" class="logo__img d-none d-inline-block-md" />
    <img id="logo-image-sm" class="d-none-md d-inline-block logo-image-sm text-white"  [ngStyle]="{width: width, height: '35px' }" [src]="customLogo ?? imgSrc" />
  </ng-container>

  <img  *ngIf="vendorConfig?.vendorSource === VendorSource.TGA" style="width: 90px;height:40px" class="d-inline-block" src="../../../../assets/images/logisti-logo.svg" />
</div>
